// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EnterAddress {
    width: 100%;
}

.enterAddressContainer {
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
}

.addressFieldGroup {
    display: flex;
    flex-direction: column;
    gap: 6px;
    width: 100%;
    position: relative;
}

.addressLabel {
    color: #839696;
    font-family: "Inter", sans-serif;
    font-size: 13.5px;
    font-weight: 500;
    letter-spacing: 0.2px;
}

.addressDropdownContainer {
    position: relative;
    width: 100%;
}

.addressSelect {
    background-color: #142424;
    border: 1px solid #233737;
    border-radius: 12px;
    height: 52px;
    padding: 0 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    box-sizing: border-box;
    transition: all 0.2s ease;
    font-family: "Inter", sans-serif;
    font-size: 15px;
    font-weight: 500;
}

.addressSelect:hover {
    border-color: #4DCBCA;
}

.addressPlaceholder {
    color: #7A7A7A;
    font-family: "Inter", sans-serif;
    font-size: 15px;
}

.addressInputText {
    color: #FFFFFF;
    font-family: "Inter", sans-serif;
    font-size: 15px;
    font-weight: 500;
}

.addressArrowIcon {
    color: #5AAF9A;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: color 0.2s ease;
}

.addressSelect:hover .addressArrowIcon {
    color: #4DCBCA;
}

.addressDropdownMenu {
    position: absolute;
    top: calc(100% + 6px);
    left: 0;
    width: 100%;
    background-color: #0E1B1B;
    border: 1px solid #1E2D2D;
    border-radius: 12px;
    box-shadow: 0 12px 36px rgba(0, 0, 0, 0.7);
    list-style: none;
    padding: 8px;
    margin: 0;
    z-index: 1000;
    max-height: 240px;
    overflow-y: auto;
    overflow-x: hidden;
    scrollbar-width: thin;
    scrollbar-color: #5AAF9A #0E1B1B;
    box-sizing: border-box;
}

.addressDropdownMenu li {
    padding: 10px 14px;
    color: #FFFFFF;
    cursor: pointer;
    border-radius: 8px;
    font-family: "Inter", sans-serif;
    font-size: 14.5px;
    font-weight: 500;
    transition: all 0.15s ease;
}

.addressDropdownMenu li:hover:not(.dropdownStatusItem) {
    background-color: #142424;
    color: #4DCBCA;
}

.addressDropdownMenu li.dropdownStatusItem {
    color: #839696;
    font-size: 13.5px;
    cursor: default;
    text-align: center;
    padding: 14px 10px;
}

.addressInputWrapper {
    width: 100%;
}

.addressInput {
    width: 100%;
    height: 52px;
    background-color: #142424;
    border: 1px solid #233737;
    border-radius: 12px;
    padding: 0 16px;
    color: #FFFFFF;
    font-family: "Inter", sans-serif;
    font-size: 15px;
    font-weight: 500;
    outline: none;
    box-sizing: border-box;
    transition: all 0.2s ease;
}

.addressInput::placeholder {
    color: #7A7A7A;
    opacity: 1;
}

.addressInput:hover {
    border-color: #4DCBCA;
}

.addressInput:focus {
    border: 1.5px solid #5AAF9A;
    box-shadow: 0 0 0 3px rgba(90, 175, 154, 0.2);
}

.addressErrorText {
    color: #FF5252;
    font-family: "Inter", sans-serif;
    font-size: 12.5px;
    margin-top: 4px;
}

.addressSubmitBtnContainer {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 10px;
}

.addressSubmitBtn {
    width: 100%;
    height: 48px;
    background-color: #5AAF9A;
    color: #0E1B1B;
    border: none;
    border-radius: 12px;
    font-family: "Inter", sans-serif;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
    box-shadow: 0 4px 14px rgba(90, 175, 154, 0.25);
}

.addressSubmitBtn:hover:not(:disabled) {
    background-color: #4DCBCA;
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(77, 203, 202, 0.35);
}

.addressSubmitBtn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

/* SignUp Mode Specific */
.EnterAddress.signUpMode {
    max-width: 480px;
    margin: 0 auto;
}

.EnterAddress.signUpMode .signInText {
    font-size: 28px;
    font-weight: 700;
    color: #FFFFFF;
    font-family: "Inter", sans-serif;
    text-align: center;
    margin-bottom: 8px;
}

/* Community Transition Notice Banner */
.addressCommunityNotice {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 12px 14px;
    border-radius: 10px;
    margin-bottom: 20px;
    font-size: 13px;
    line-height: 1.45;
    font-family: "Inter", sans-serif;
    box-sizing: border-box;
    width: 100%;
    animation: fadeInNotice 0.25s ease;
}

@keyframes fadeInNotice {
    from {
        opacity: 0;
        transform: translateY(-4px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.addressCommunityNotice.notice-warning {
    background-color: rgba(245, 158, 11, 0.1);
    border: 1px solid rgba(245, 158, 11, 0.35);
    color: #fde68a;
}

.addressCommunityNotice.notice-info {
    background-color: rgba(77, 203, 202, 0.08);
    border: 1px solid rgba(77, 203, 202, 0.25);
    color: #99f6e4;
}

.addressCommunityNotice .noticeIcon {
    font-size: 16px;
    line-height: 1;
    margin-top: 2px;
    flex-shrink: 0;
}

.addressCommunityNotice .noticeText {
    flex: 1 1;
}

.addressCommunityNotice strong {
    color: #ffffff;
    font-weight: 600;
}`, "",{"version":3,"sources":["webpack://./src/Components/SignUpFlow/EnterAddress/EnterAddress.css"],"names":[],"mappings":"AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,gCAAgC;IAChC,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,sBAAsB;IACtB,yBAAyB;IACzB,gCAAgC;IAChC,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,gCAAgC;IAChC,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,gCAAgC;IAChC,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,OAAO;IACP,WAAW;IACX,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,0CAA0C;IAC1C,gBAAgB;IAChB,YAAY;IACZ,SAAS;IACT,aAAa;IACb,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;IACrB,gCAAgC;IAChC,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,gCAAgC;IAChC,iBAAiB;IACjB,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,cAAc;IACd,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,UAAU;AACd;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;IACI,cAAc;IACd,gCAAgC;IAChC,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,cAAc;IACd,YAAY;IACZ,mBAAmB;IACnB,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,+CAA+C;AACnD;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;IAC3B,+CAA+C;AACnD;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA,yBAAyB;AACzB;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gCAAgC;IAChC,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA,uCAAuC;AACvC;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,gCAAgC;IAChC,sBAAsB;IACtB,WAAW;IACX,kCAAkC;AACtC;;AAEA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI,yCAAyC;IACzC,0CAA0C;IAC1C,cAAc;AAClB;;AAEA;IACI,0CAA0C;IAC1C,0CAA0C;IAC1C,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap\");\n\n.EnterAddress {\n    width: 100%;\n}\n\n.enterAddressContainer {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    width: 100%;\n}\n\n.addressFieldGroup {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n    width: 100%;\n    position: relative;\n}\n\n.addressLabel {\n    color: #839696;\n    font-family: \"Inter\", sans-serif;\n    font-size: 13.5px;\n    font-weight: 500;\n    letter-spacing: 0.2px;\n}\n\n.addressDropdownContainer {\n    position: relative;\n    width: 100%;\n}\n\n.addressSelect {\n    background-color: #142424;\n    border: 1px solid #233737;\n    border-radius: 12px;\n    height: 52px;\n    padding: 0 16px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    cursor: pointer;\n    box-sizing: border-box;\n    transition: all 0.2s ease;\n    font-family: \"Inter\", sans-serif;\n    font-size: 15px;\n    font-weight: 500;\n}\n\n.addressSelect:hover {\n    border-color: #4DCBCA;\n}\n\n.addressPlaceholder {\n    color: #7A7A7A;\n    font-family: \"Inter\", sans-serif;\n    font-size: 15px;\n}\n\n.addressInputText {\n    color: #FFFFFF;\n    font-family: \"Inter\", sans-serif;\n    font-size: 15px;\n    font-weight: 500;\n}\n\n.addressArrowIcon {\n    color: #5AAF9A;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: color 0.2s ease;\n}\n\n.addressSelect:hover .addressArrowIcon {\n    color: #4DCBCA;\n}\n\n.addressDropdownMenu {\n    position: absolute;\n    top: calc(100% + 6px);\n    left: 0;\n    width: 100%;\n    background-color: #0E1B1B;\n    border: 1px solid #1E2D2D;\n    border-radius: 12px;\n    box-shadow: 0 12px 36px rgba(0, 0, 0, 0.7);\n    list-style: none;\n    padding: 8px;\n    margin: 0;\n    z-index: 1000;\n    max-height: 240px;\n    overflow-y: auto;\n    overflow-x: hidden;\n    scrollbar-width: thin;\n    scrollbar-color: #5AAF9A #0E1B1B;\n    box-sizing: border-box;\n}\n\n.addressDropdownMenu li {\n    padding: 10px 14px;\n    color: #FFFFFF;\n    cursor: pointer;\n    border-radius: 8px;\n    font-family: \"Inter\", sans-serif;\n    font-size: 14.5px;\n    font-weight: 500;\n    transition: all 0.15s ease;\n}\n\n.addressDropdownMenu li:hover:not(.dropdownStatusItem) {\n    background-color: #142424;\n    color: #4DCBCA;\n}\n\n.addressDropdownMenu li.dropdownStatusItem {\n    color: #839696;\n    font-size: 13.5px;\n    cursor: default;\n    text-align: center;\n    padding: 14px 10px;\n}\n\n.addressInputWrapper {\n    width: 100%;\n}\n\n.addressInput {\n    width: 100%;\n    height: 52px;\n    background-color: #142424;\n    border: 1px solid #233737;\n    border-radius: 12px;\n    padding: 0 16px;\n    color: #FFFFFF;\n    font-family: \"Inter\", sans-serif;\n    font-size: 15px;\n    font-weight: 500;\n    outline: none;\n    box-sizing: border-box;\n    transition: all 0.2s ease;\n}\n\n.addressInput::placeholder {\n    color: #7A7A7A;\n    opacity: 1;\n}\n\n.addressInput:hover {\n    border-color: #4DCBCA;\n}\n\n.addressInput:focus {\n    border: 1.5px solid #5AAF9A;\n    box-shadow: 0 0 0 3px rgba(90, 175, 154, 0.2);\n}\n\n.addressErrorText {\n    color: #FF5252;\n    font-family: \"Inter\", sans-serif;\n    font-size: 12.5px;\n    margin-top: 4px;\n}\n\n.addressSubmitBtnContainer {\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-top: 10px;\n}\n\n.addressSubmitBtn {\n    width: 100%;\n    height: 48px;\n    background-color: #5AAF9A;\n    color: #0E1B1B;\n    border: none;\n    border-radius: 12px;\n    font-family: \"Inter\", sans-serif;\n    font-size: 16px;\n    font-weight: 600;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: all 0.2s ease;\n    box-shadow: 0 4px 14px rgba(90, 175, 154, 0.25);\n}\n\n.addressSubmitBtn:hover:not(:disabled) {\n    background-color: #4DCBCA;\n    transform: translateY(-2px);\n    box-shadow: 0 6px 20px rgba(77, 203, 202, 0.35);\n}\n\n.addressSubmitBtn:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n}\n\n/* SignUp Mode Specific */\n.EnterAddress.signUpMode {\n    max-width: 480px;\n    margin: 0 auto;\n}\n\n.EnterAddress.signUpMode .signInText {\n    font-size: 28px;\n    font-weight: 700;\n    color: #FFFFFF;\n    font-family: \"Inter\", sans-serif;\n    text-align: center;\n    margin-bottom: 8px;\n}\n\n/* Community Transition Notice Banner */\n.addressCommunityNotice {\n    display: flex;\n    align-items: flex-start;\n    gap: 12px;\n    padding: 12px 14px;\n    border-radius: 10px;\n    margin-bottom: 20px;\n    font-size: 13px;\n    line-height: 1.45;\n    font-family: \"Inter\", sans-serif;\n    box-sizing: border-box;\n    width: 100%;\n    animation: fadeInNotice 0.25s ease;\n}\n\n@keyframes fadeInNotice {\n    from {\n        opacity: 0;\n        transform: translateY(-4px);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n.addressCommunityNotice.notice-warning {\n    background-color: rgba(245, 158, 11, 0.1);\n    border: 1px solid rgba(245, 158, 11, 0.35);\n    color: #fde68a;\n}\n\n.addressCommunityNotice.notice-info {\n    background-color: rgba(77, 203, 202, 0.08);\n    border: 1px solid rgba(77, 203, 202, 0.25);\n    color: #99f6e4;\n}\n\n.addressCommunityNotice .noticeIcon {\n    font-size: 16px;\n    line-height: 1;\n    margin-top: 2px;\n    flex-shrink: 0;\n}\n\n.addressCommunityNotice .noticeText {\n    flex: 1;\n}\n\n.addressCommunityNotice strong {\n    color: #ffffff;\n    font-weight: 600;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
